import api from './axios';

export async function add_document(document_data) {
    try {
        const response = await api.post('/documents/add', document_data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    }
    catch (err) {
        throw err;
    }
}

export const get_documents_by_beneficiary_id = async (beneficiary_id) => {
    try {
        const response = await api.get(`/documents/${beneficiary_id}`);
        return response.data;
    }
    catch (err) {
        throw err;
    }
};

export const delete_document_by_id = async (document_id) => {
    try {
        const response = await api.delete(`/documents/delete/${document_id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const delete_documents_by_beneficiary_id = async (beneficiary_id) => {
    try {
        const response = await api.delete(`/documents/delete/beneficiary/${beneficiary_id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const download_document_by_id = async (document_id) => {
    try {
        const response = await api.get(`/documents/download/${document_id}`);
        return response.data.url;
    } catch (error) {
        throw error;
    }
};

export const view_document_by_id = async (document_id) => {
    try {
        const response = await api.get(`/documents/view/${document_id}`);
        return response.data.url;
    } catch (error) {
        throw error;
    }
};